import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
import { LayoutType } from '../../../types/shared';
const CouponTitle = ({ title, layoutType = LayoutType.SINGLE, className = '', style }) => {
    return <View className={`coupon-title ${className}`} style={style}>
      <Text className={`coupon-title-text coupon-title-${layoutType}`} numberOfLines={1}>
        {title}
      </Text>
    </View>;
};
export default memo(CouponTitle);
